import {Component, OnInit, ViewChild} from '@angular/core';

import {AlertService, AuthenticationService, ClientProfileService, ProjectService} from '../../_services';

import {ActivatedRoute, Router} from '@angular/router';

import {PoamItem, Project, User} from '../../_models';
import {LoginHelper} from '../../helpers';
import {IndexConfigService} from "../../_services/index.config.service";
import {ActionPlan} from "../../_models/actionPlan";
import {FormBuilder, Validators} from "@angular/forms";
import {SelectProjectControlItemComponent} from "../selectProjectControlItem/select-project-control-item.component";
import {
  SelectSingleProjectControlItemComponent
} from "../selectSingleProjectControlItem/select-single-project-control-item.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import { DictionaryService } from "../../_services/dictionary.service";
import { AppTextResourcesService } from '../../_services/app.text.resources.service';
import {InspectionResultsPopupComponent} from "../inspectionResultsPopup/inspectionResultsPopup.component";
import {DialogService} from "primeng/dynamicdialog";
import {CveService} from "../../_services/cve.service";
import {Constants} from "../../helpers/constants";

@Component({
    standalone: false,
  selector: "cve-component",
  templateUrl: './cve.component.html',
  styleUrls: ['./cve.component.scss'],
})

export class CveComponent implements OnInit {
  cve: any[] = [];
  currentUser: User;
  tenantName: string;
  isMaster = false;
  lowMediumHigh = {0: 'Low', 1: 'Medium', 2: 'High'};

  constructor(
    public projectService: ProjectService,
    public router: Router,
    public route: ActivatedRoute,
    public formBuilder: FormBuilder,
    public alertService: AlertService,
    public config: IndexConfigService,
    public authenticationService: AuthenticationService,
    public cveService: CveService,
    public dictionaryService: DictionaryService,
    public dialog: MatDialog,
    public dialogService: DialogService,
    public clientProfileService: ClientProfileService,
    private constants: AppTextResourcesService) {

    const tenantName = this.tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.isMaster = this.isMaster = tenantName == Constants.RiskSpongeMaster;
  }

  ngOnInit() {
    this.cveService.getCveItems().subscribe(d => this.cve = d);
  }

  updateCve() {
    this.cveService.updateCve().subscribe(() => {
      this.ngOnInit();
    });
  }
}
